import { useTranslation } from 'react-i18next';
import { CharCount, EditorShell, MessageTextarea } from './styles';

/**
 * 참조메일 "Message" 입력기 — 단순 textarea 포팅. 4000자는 하드 maxLength 아닌
 * 소프트 제한(초과 시 경고색 + 부모 submit 차단) — 기존 동작 유지.
 */

export const MESSAGE_MAX_LENGTH = 4000;

type MessageEditorProps = {
  value: string;
  onChange: (value: string) => void; // 입력 변경 시 평문 value 를 부모로 노출 — submit 시 부모가 이 값을 payload 로 사용.
};

const MessageEditor = ({ value, onChange }: MessageEditorProps) => {
  const { t } = useTranslation();
  const length = value.length;
  const isOver = length > MESSAGE_MAX_LENGTH;

  return (
    <EditorShell className={isOver ? 'over' : undefined}>
      <MessageTextarea
        value={value}
        placeholder={t('참조인에게 메시지를 보낼 수 있어요.')}
        onChange={(e) => onChange(e.target.value)}
      />
      <CharCount className={isOver ? 'over' : undefined}>
        {length.toLocaleString()} / {MESSAGE_MAX_LENGTH.toLocaleString()}
      </CharCount>
    </EditorShell>
  );
};

export default MessageEditor;
